import axios from "axios";
import {
  loginStart,
  loginSuccess,
  loginFailure,
  registerStart,
  registerSuccess,
  registerFailure,
} from "./userRedux";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const loginUser = async (dispatch, credentials) => {
  dispatch(loginStart());
  try {
    const res = await axios.post(`${BASE_URL}/auth/login`, credentials);
    dispatch(loginSuccess(res.data));
  } catch (err) {
    dispatch(loginFailure());
    throw err;
  }
};

export const registerUser = async (dispatch, userInfo) => {
  dispatch(registerStart());
  try {
    const res = await axios.post(`${BASE_URL}/auth/register`, userInfo);
    dispatch(registerSuccess(res.data));
  } catch (err) {
    dispatch(registerFailure());
    throw err;
  }
};
